module.exports = __webpack_public_path__ + "img/gourmet4.753e6db9.jpg";